import { render, staticRenderFns } from "./RedDot.vue?vue&type=template&id=2c3922aa&scoped=true"
import script from "./RedDot.vue?vue&type=script&lang=js"
export * from "./RedDot.vue?vue&type=script&lang=js"
import style0 from "./RedDot.vue?vue&type=style&index=0&id=2c3922aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3922aa",
  null
  
)

export default component.exports